import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[600px] md:h-[680px] flex items-center justify-center overflow-hidden">
      <img
        src="https://readdy.ai/api/search-image?query=modern%20luxury%20home%20theater%20cinema%20room%20with%20large%20projector%20screen%20showing%20epic%20movie%20scene%20warm%20ambient%20lighting%20cozy%20seats%20dark%20walls%20with%20LED%20accents%20cinematic%20atmosphere%20golden%20hour%20glow%20professional%20interior%20design%20photography%20high%20end&width=1600&height=900&seq=mahua-hero-bg&orientation=landscape"
        alt="麻花视频 - 在线观影平台"
        className="absolute inset-0 w-full h-full object-cover"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/35 to-black/65"></div>

      <div className="relative z-10 w-full container-page text-center">
        <h1 className="text-4xl md:text-5xl lg:text-6xl font-heading font-bold text-white mb-5 leading-tight">
          麻花视频
        </h1>
        <p className="text-lg md:text-xl text-white/85 mb-3 max-w-2xl mx-auto leading-relaxed">
          海量电视剧免费在线观看，高清全集不缓冲
        </p>
        <p className="text-sm md:text-base text-white/60 mb-8 max-w-xl mx-auto">
          涵盖最新电视剧全集 · 电影免费看 · 无需会员即可享受流畅观影体验
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/dianshiju"
            className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-semibold text-base hover:bg-primary-600 transition-all duration-300 cursor-pointer whitespace-nowrap shadow-lg shadow-primary-500/25"
          >
            <i className="ri-play-circle-line mr-2"></i>
            开始观影
          </Link>
          <Link
            to="/category/dianying"
            className="px-8 py-3.5 rounded-full border-2 border-white/30 text-white font-semibold text-base hover:bg-white/10 transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            <i className="ri-film-line mr-2"></i>
            热门电影
          </Link>
        </div>

        <div className="mt-10 flex items-center justify-center gap-8">
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">10万+</div>
            <div className="text-xs text-white/55 mt-1">视频资源</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-accent-400">500万+</div>
            <div className="text-xs text-white/55 mt-1">日活用户</div>
          </div>
          <div className="w-px h-10 bg-white/20"></div>
          <div className="text-center">
            <div className="text-2xl md:text-3xl font-heading font-bold text-white">99.8%</div>
            <div className="text-xs text-white/55 mt-1">高清覆盖率</div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 z-10">
        <div className="w-8 h-12 rounded-full border-2 border-white/30 flex items-start justify-center pt-2">
          <div className="w-1.5 h-3 rounded-full bg-white/60 animate-bounce"></div>
        </div>
      </div>
    </section>
  );
}